import { useState, useEffect } from "react";
import './Notes.css';
import { FiChevronDown, FiChevronsDown, FiSearch } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
// import { FiX } from "react-icons/fi";

function NotesModal({
    show,
    phoneNumber,
    setDatasetID,
    setSelectedAgency,
    notes,
    setNotes,
    agencies,
    onClear,
    onSubmit,
    setAgencyID,
    selectedAgency,
    isDisabled,
    selectedDataset,
    setSelectedDataset,
    onClose,
}) {
    const [agencySearch, setAgencySearch] = useState("");
    const [datasetSearch, setDatasetSearch] = useState("");

    const [isAgencyDropdownOpen, setIsAgencyDropdownOpen] = useState(false);
    const [isDatasetDropdownOpen, setIsDatasetDropdownOpen] = useState(false);

    const [errors, setErrors] = useState({ agency: false, notes: false });

    useEffect(() => {
        if (!show) {
            setAgencySearch("");
            setDatasetSearch("");
            setIsAgencyDropdownOpen(false);
            setIsDatasetDropdownOpen(false);
            setErrors({ agency: false, notes: false });
        }
    }, [show]);
    useEffect(() => {
        setAgencySearch(selectedAgency || "");
    }, [selectedAgency]);

    useEffect(() => {
        setDatasetSearch(selectedDataset || "");
    }, [selectedDataset]);

    if (!show) return null;

    const handleSubmit = () => {
        const agencyMissing = !agencySearch.trim();
        const notesMissing = !notes.trim();

        if (agencyMissing || notesMissing) {
            setErrors({ agency: agencyMissing, notes: notesMissing });
            return;
        }

        setErrors({ agency: false, notes: false });
        onSubmit();
    };

    const handleClear = () => {
        setErrors({ agency: false, notes: false });
        setIsAgencyDropdownOpen(false);
        setIsDatasetDropdownOpen(false);
        onClear();
    };

    const datasets = [...new Map(
        agencies.map(item => [item.datasetID, item])
    ).values()];

    const filteredDatasets = datasetSearch
        ? datasets.filter(item =>
            item.datasetID
                ?.toLowerCase()
                .includes(datasetSearch.toLowerCase())
        )
        : datasets;

    const filteredAgencies = agencies.filter(
        agency =>
            (!selectedDataset ||
                agency.datasetID === selectedDataset) &&
            (
                !agencySearch ||
                agency.agencyName
                    ?.toLowerCase()
                    .includes(agencySearch.toLowerCase())
            )
    );

    const selectDataset = (dataset) => {
        setSelectedDataset(dataset.datasetID);
        setDatasetID(dataset.datasetID);

        setDatasetSearch(dataset.datasetID);

        setAgencySearch("");
        setSelectedAgency("");
        setAgencyID("");

        setIsDatasetDropdownOpen(false);
    };

    const selectAgency = (agency) => {
        setAgencySearch(agency.agencyName);

        setSelectedAgency(agency.agencyName);
        setAgencyID(agency.agencyID);
        setDatasetID(agency.datasetID);

        setIsAgencyDropdownOpen(false);
    };

    return (
        <div className="notes-modal-overlay"
        >
            <div className="notes-modal-container">
                {isDisabled && (
                    <div className="notes-modal-disabled-overlay" />
                )}

                <div className="notes-header">
                    <h2 className="notes-title">Notes</h2>

                    <button
                        type="button"
                        className="notes-close-btn"
                        onClick={onClose}
                    >
                        <MdCancel />
                    </button>
                </div>

                <div className="notes-content">
                    {/* PHONE */}
                    <div className="notes-control-group">
                        <label className="notes-label">
                            Incoming Number
                        </label>
                        <input
                            type="text"
                            value={phoneNumber}
                            readOnly
                            className="notes-readonly-input"
                        />
                    </div>

                    <div className="notes-control-group">
                        <label className="notes-label">
                            Dataset
                        </label>

                        <div
                            className="notes-search-select"
                            onBlur={(e) => {
                                if (!e.currentTarget.contains(e.relatedTarget)) {
                                    setIsDatasetDropdownOpen(false);
                                }
                            }}
                        >
                            <input
                                value={datasetSearch}
                                disabled={isDisabled}
                                onChange={(e) => {
                                    setDatasetSearch(e.target.value);
                                    setIsDatasetDropdownOpen(true);
                                }}
                                onFocus={() => {
                                    if (!isDisabled) {
                                        setIsDatasetDropdownOpen(true);
                                    }
                                }}
                                placeholder="Select Dataset"
                            />

                            <button
                                className="notes-search-select-toggle"
                                type="button"
                                disabled={isDisabled}
                                onClick={() => {
                                    if (!isDisabled) {
                                        setDatasetSearch("");
                                        setIsDatasetDropdownOpen((prev) => !prev);
                                    }
                                }}
                            >
                                <FiChevronDown />
                            </button>

                            {isDatasetDropdownOpen && (
                                <div className="notes-search-select-menu">
                                    {filteredDatasets.map((dataset) => (
                                        <button
                                            key={dataset.datasetID}
                                            type="button"
                                            className="notes-search-select-option"
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={() => selectDataset(dataset)}
                                        >
                                            {dataset.datasetID}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* AGENCY */}
                    <div className="notes-control-group">
                        <label className="notes-label">Agency</label>

                        <div
                            className={`notes-search-select ${!selectedDataset ? "disabled" : ""}`}
                            onBlur={(e) => {
                                if (!e.currentTarget.contains(e.relatedTarget)) {
                                    setIsAgencyDropdownOpen(false);
                                }
                            }}
                        >
                            <input
                                value={agencySearch}
                                onChange={(e) => {
                                    setAgencySearch(e.target.value);
                                    setIsAgencyDropdownOpen(true);
                                }}
                                onFocus={() => {
                                    if (selectedDataset) {
                                        setIsAgencyDropdownOpen(true);
                                    }
                                }}
                                placeholder="Select Agency"
                                disabled={!selectedDataset}
                            />

                            <button
                                className="notes-search-select-toggle"
                                type="button"
                                disabled={!selectedDataset}
                                onClick={() => {
                                    if (selectedDataset) {
                                        setAgencySearch("");
                                        setIsAgencyDropdownOpen((prev) => !prev);
                                    }
                                }}
                            >
                                <FiChevronDown />
                            </button>

                            {isAgencyDropdownOpen && (
                                <div className="notes-search-select-menu">
                                    {filteredAgencies.map((agency) => (
                                        <button
                                            key={agency.agencyID}
                                            type="button"
                                            className="notes-search-select-option"
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={() => selectAgency(agency)}
                                        >
                                            {agency.agencyName}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* NOTES */}
                    <div className="notes-control-group">
                        <label className="notes-label">
                            Notes
                        </label>

                        <textarea
                            rows={6}
                            value={notes}
                            disabled={isDisabled}
                            onChange={(e) => {
                                setNotes(e.target.value);
                                if (e.target.value.trim()) {
                                    setErrors((prev) => ({ ...prev, notes: false }));
                                }
                            }}
                            placeholder="Enter call notes..."
                            className={`notes-textarea ${errors.notes ? "notes-textarea-error" : ""
                                }`}
                        />

                        {errors.notes && (
                            <p className="notes-error-text">
                                Please enter call notes.
                            </p>
                        )}
                    </div>


                    {/* ACTIONS */}
                    <div className="mt-2 notes-actions">
                        <button
                            onClick={handleClear}
                            disabled={isDisabled}
                            className="notes-clear-btn"
                        >
                            Clear
                        </button>

                        <button
                            onClick={handleSubmit}
                            disabled={isDisabled}
                            className="notes-submit-btn"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NotesModal;